import { Component } from '@angular/core';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { UserService } from '../_Services/user.service';
import { Router, ActivatedRoute } from '@angular/router';  
import { CommonService } from '../_Services/common.service';

@Component({
  templateUrl: 'edit.component.html'
})
export class EditComponent {

	model: any = {};
    groups = [];

    user = [];
    group = [];

    responseStatus:Object= [];
    status:boolean ;
    error = ''; 
	constructor(private router: Router, private userService: UserService, private commonService: CommonService, private route:ActivatedRoute) { }

	onSubmit() { 
		this.userService.addUser(this.model).subscribe(result => {
            console.log(result);
            if (result.status === true) {
                this.error = '';
                this.router.navigate(['/users/users']);
            } else {
                this.error = result.message; 
            }
        }); 
	}

    changeShape(group_id){ 
        this.model.group_id = group_id;
    }

    ngOnInit() {  
        this.commonService.getGroups().subscribe(result => { 
            this.groups = result;
        });  

        var id = this.route.snapshot.params['id'];
        this.userService.viewUser(id).subscribe(result => { 
            this.user = result.data.User; 
            this.group = result.data.Group;
            console.log(result.data.User.id);
      });  
    }

}



// WEBPACK FOOTER //
// ./src/app/users/edit.component.ts